module.exports = __webpack_public_path__ + "img/ic-deals-active.5366f722.svg";